import Styled, { withTheme } from "styled-components";

const LoadingSpinner = Styled.div`
  border: 5px solid #f3f3f3;
  /*Grey*/
  border-top: 5px solid ${props => props.theme.computedPrimary};
  /*Primary Color*/
  border-radius: 50%;
  width: ${props => `${props.size}px` || "50px"};
  height:${props => `${props.size}px` || "50px"};
  margin: auto;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default withTheme(LoadingSpinner);
